module.exports = __webpack_public_path__ + "img/time.6ff16a72.svg";